<router-outlet></router-outlet>

<ngx-spinner
    bdOpacity = 0.8
    bdColor = "rgba(231,223,223,0.71)"
    size = "default"
    color = "#08a191"
    type = "ball-spin"
    [fullScreen] = "true" 
 
>
</ngx-spinner>